
export function closePopup(popup) {
    popup.classList.add('hidden');
}

export function openPopup(popup) {
    popup.classList.remove('hidden');
}

/**
 * adds EventListenerst for opening and closing popups
 */
export function includePopups() {
    const popups = Array.from(document.querySelectorAll('.popup'));

    // adds Eventlistenerst for closing popups
    popups.forEach(popup => {
        if(popup.classList.contains('consent'))return;
        popup.addEventListener('click', function(e) {
            const clicked = e.target;
            if(!clicked.classList.contains('popup') && !clicked.classList.contains('popup__close')) return;
            closePopup(popup);
        })
    });


    // to make an image zoomable give it the class of img-zoomable
    const zoomableImgs = Array.from(document.querySelectorAll('.img-zoomable'));
    const imgPopup = document.querySelector('#imgPopup');

    // adds Eventlisteners for zoomable images to open popups
    zoomableImgs.forEach(img => {
        img.addEventListener('click', function() {
            img = img.cloneNode();
            img.setAttribute('class', 'popup__img');
            img.setAttribute('style', '');
            imgPopup.innerHTML = `<div class="popup__close">x</div>`;
            imgPopup.insertAdjacentElement('beforeend', img);
            openPopup(imgPopup);
        })
    });
}

